import { ffhClient } from '@lib/api/ffh-client';

type ResetPasswordResult =
  | { isSuccess: true }
  | { isSuccess: false; message: string };

const RESET_PASSWORD_ERROR_MESSAGE =
  'Something went wrong requesting your password reset. Please try again.';

export const resetPassword = async (values: {
  email: string;
}): Promise<ResetPasswordResult> => {
  const { error } = await ffhClient().POST('/users/me/password/reset', {
    body: { email: values.email.trim() }
  });

  if (error) {
    return { isSuccess: false, message: RESET_PASSWORD_ERROR_MESSAGE };
  }

  return { isSuccess: true };
};
